export const ENUM = {
  PERMISSION: {
    CENTER: "center",
    VENDOR: "vendor",
    VENDOR_ADMIN: "vendor-admin",
    VENDOR_SALES: "vendor-sales",
    VENDOR_SECURITY: "vendor-security",
  },
}
